import AcceptInvitation from './acceptInvitation';
import { AnonymousAssetById } from './anonymousAssetById';
import { Invitation } from './invitation';

export const anonymousRoutes = [
  { path: '/anonymous/assets/:assetId', element: <AnonymousAssetById /> },
  { path: '/invitation/:invitationId/:workspaceId', element: <Invitation /> },
  {
    path: '/acceptInvitation/:invitationId/:workspaceId',
    element: <AcceptInvitation />,
  },
  // An asset share link's create-profile page: the same page, with the share
  // token standing in for the invitation id (built by `acceptSharePath`). The
  // static `share` segment outranks `:invitationId` on React Router's route
  // score, so this never depends on table order.
  {
    path: '/acceptInvitation/share/:shareToken',
    element: <AcceptInvitation />,
  },
];
